import { nativeEnum, object, string, boolean, ZodIssueCode } from 'zod';

import { Breakage_Point_Rounding } from '@occc/graphql';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const VoucherStackingFormValuesSchema = object({
  id: string().optional(),
  isEnabled: boolean().default(false),
  breakageRefund: boolean().default(false),
  breakagePointRounding: nativeEnum(Breakage_Point_Rounding).nullable().default(null),
}).superRefine((data, ctx) => {
  if (data.breakageRefund && !data.breakagePointRounding) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      path: ['breakagePointRounding'],
      message: IS_REQUIRED,
    });
  }
});
